export const environment = {
  baseUrl: 'https://findleasing.asgd.dk/',
  apiUrl: 'https://backend.findleasing.nu/api/v2',
  production: false,
  //strapiUrl: 'http://127.0.0.1:1337',
  strapiUrl: 'https://cms.findleasing.asgd.dk/',
};
